module.exports = __webpack_public_path__ + "static/select_your_sport-fc9f5dbe8fda5381b2a5ffe5b83e29ca.jpg";